import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API = `${BASE}/api`;

const client = axios.create({ baseURL: API, timeout: 20000 });

client.interceptors.request.use((config) => {
  const token = localStorage.getItem("ff_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

client.interceptors.response.use(
  (r) => r,
  (err) => {
    // Optional: auto sign-out on 401
    if (err?.response?.status === 401) {
      const path = window.location.pathname;
      const publicPaths = ["/", "/login", "/register"];
      if (!publicPaths.includes(path)) {
        localStorage.removeItem("ff_token");
        localStorage.removeItem("ff_user");
      }
    }
    return Promise.reject(err);
  }
);

export default client;

export const api = {
  // Auth
  register: (data) => client.post("/auth/register", data).then((r) => r.data),
  login: (data) => client.post("/auth/login", data).then((r) => r.data),
  me: () => client.get("/auth/me").then((r) => r.data),
  updateMe: (patch) => client.patch("/auth/me", patch).then((r) => r.data),

  // Community
  feed: (params = {}) => client.get("/community/feed", { params }).then((r) => r.data),
  createPost: (data) => client.post("/community/posts", data).then((r) => r.data),

  // Members
  members: (params = {}) => client.get("/members", { params }).then((r) => r.data),
  member: (id) => client.get(`/members/${id}`).then((r) => r.data),

  // Domain data
  festivals: () => client.get("/festivals").then((r) => r.data),
  jobs: () => client.get("/jobs").then((r) => r.data),
  orgs: () => client.get("/orgs").then((r) => r.data),
  productions: () => client.get("/productions").then((r) => r.data),
};
